module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"clear":"Leeren","confirmClear":"Liste leeren"},"en":{"clear":"Clear","confirmClear":"Really clear?"}}')
  delete Component.options._Ctor
}
